<ng-container>

    <mat-card appCard style="background-color: white;">
        <mat-card-content class="card-content" style=" text-align: center; padding: 0">
            <ng-container *ngIf="portail">
                <img alt="image" src="assets/images/tuneps.svg" style="height: 6rem;"/>
                <br>
                <br>
                <p style="font-size: 1.3rem;font-weight: bold;" translate>Système électronique de passation des marchés
                    publics</p>
                <h1 style="font-size: 2.2rem; color: #C0392B;" translate>Connexion de l’utilisateur</h1>
                <span layout="row">
                <hr class="st-hr" flex/>
              </span>
            </ng-container>
            <div *ngIf="certiflocalbool" class="mt-3">
                <mat-card appCard class="table-card">
                    <mat-card-content>
                        <table
                                [dataSource]="dataSource"
                                mat-table
                                style="width: 100%"
                        >
                            <ng-container *ngFor="let column of readColumns" [matColumnDef]="column">
                                <th *matHeaderCellDef mat-header-cell translate>
                                    <span> {{ labels[column] | translate }}</span>
                                </th>
                                <td *matCellDef="let type" mat-cell translate>
                                    <span> {{ type[column] | typedValue | async | translate}}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="action">
                                <th *matHeaderCellDef mat-header-cell>{{'Plus de détails' |translate}} </th>
                                <td *matCellDef="let certif" mat-cell>
                                    <a (click)="openCertif(certif)" mat-icon-button>
                                        <mat-icon style="color: #00a8ff;">info</mat-icon>
                                    </a>

                                </td>
                            </ng-container>
                            <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
                            <tr (click)="selection.toggle(row)" (click)="toggle(row)" (mouseout)="row.hovered = false"
                                (mouseover)="row.hovered = true" *matRowDef="let row; columns: displayedColumns"
                                [ngClass]="{hovered: row.hovered, highlighted: selection.isSelected(row)} "
                                mat-row style="cursor: pointer"></tr>
                        </table>
                        <app-empty-list-container
                                [list]="dataSource.data"
                                [withoutBorder]="true"
                        ></app-empty-list-container>
                        <app-paginator
                                (paginate)="onPaginate($event)"
                                [pageSize]="paginationObject.limit"
                                [total]="certificates.length"
                        ></app-paginator>
                    </mat-card-content>
                </mat-card>
                <div class="mt-3" fxLayout="row wrap">
                    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutAlign="start center">
                        <button (click)="goToPortail()" *ngIf="portail" color="primary" mat-raised-button>
                            <span translate>{{ 'Accueil' | translate}}</span>
                        </button>
                    </div>
                    <div fxFlex="{{portail? 50:100}}" fxFlex.lt-md="100" fxLayoutAlign="end center">
                        <button (click)="login()" [disabled]="disabled_conn" [ngClass]="disabled_conn? 'disabled-btn': 'connect-btn'"
                                class="mx-2" mat-raised-button>
                            <span translate>{{ portail ? ("Se connecter"|translate) : ("select"|translate)}}</span>
                        </button>
                        <!--                    <button mat-flat-button class="connecter" (click)="login()" translate-->
                        <!--                            [disabled]="disabled_conn">{{ portail ? ("Se connecter"|translate) : ("select"|translate)}}</button>-->
                        <div *ngIf="portail">
                            <!--                        <button mat-flat-button class=" rafr" translate-->
                            <!--                                (click)="reload()">{{"Rafraichir"|translate}}</button>-->
                            <button (click)="reload()" class="reload-btn" mat-raised-button>
                                <span translate>{{"Rafraichir"|translate}}</span>
                            </button>
                        </div>
                    </div>

                </div>
                <!--                <div style="text-align:center; ">-->
                <!--                    <button mat-flat-button class="connecter" (click)="login()" translate-->
                <!--                            [disabled]="disabled_conn">{{ portail ? ("Se connecter"|translate) : ("select"|translate)}}</button>-->
                <!--                </div>-->
                <!--                <div style="text-align:center; " *ngIf="portail">-->
                <!--                    <button mat-flat-button class=" rafr" translate-->
                <!--                            (click)="reload()">{{"Rafraichir"|translate}}</button>-->
                <!--                </div>-->
            </div>
            <div *ngIf="!certiflocalbool&&portail">
                <div style="width: 100%;padding-right: 20%;padding-left: 20%;padding-top: 4%; padding-bottom: 4%; font-size: 1.2rem;">
                    <p>
                        Pour pouvoir utiliser votre certificat électronique sur la platforme Tuneps,
                        nous vous invitons à télécharger l'utilitaire depuis <br>
<!--                        <a (click)="downloadLoaclServer()" style="color: #4779b2;font-weight: bold;"> ce lien</a>-->
                        <a  style="font-weight: bold; text-decoration: underline" (click)="downloadLoacalServer()" rel="noopener noreferrer">
                            ce lien
                        </a>
                    </p>
                    <p>Procéder ensuite à son installation conformément au manuel : <br>
                        <a href="http://www.tuneps-kit.tn/00/technical.php" style="font-weight: bold;text-decoration: underline" target="_blank">tuneps-kit.tn</a>
                    </p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
<app-spinner-container [color]="spinnerConfig.color"
                       [diametre]="spinnerConfig.diametre"
                       [isLoading]="spinnerConfig.isLoading"
                       [mode]="spinnerConfig.mode"
                       [msg]="spinnerConfig.msg"
                       [value]="spinnerConfig.value">
</app-spinner-container>
